import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { MenuContainer } from './MenuContainer';
import { Button } from '../common';
import { selectNft } from '../../store/userStore';

export interface IDegenRacerByCollectionProps {
  nftsOwned: any[];
  baseSource: string;
  collectionName: string;
  onClickMainMenu: () => void;
  onClickBack: () => void;
}

export const DegenRacerByCollection = (props: IDegenRacerByCollectionProps) => {
  const dispatch = useDispatch();
  const { nftsOwned, collectionName, onClickMainMenu, onClickBack, baseSource } = props;

  const openLink = (link: string) => {
    window.open(link, '_blank');
  };

  const onSelectDegen = (nft: string) => () => {
    const nrNFT = collectionName + '#' + nft;
    console.log('nrNFT', nrNFT);
    localStorage.setItem('nrNFT', nrNFT);
    dispatch(selectNft(nrNFT));

    onClickMainMenu();
  };

  const footer = (
    <>
      <Button label={'Back'} secondary={true} className={'mx-2'} onClick={onClickBack} />
      <Button
        label={'Mint Bitcoin Degen'}
        secondary={true}
        className={'mx-2'}
        onClick={() => openLink('https://stacksdegens.com/mint-bitcoin-degens/')}
      />
    </>
  );

  if (nftsOwned.length === 0) {
    // No nft for this collection
    return (
      <MenuContainer
        content={
          <div className="card">
            <div className="card-body">
              <h3 className="card-title card-lead">No NFT available for this collection</h3>
            </div>
          </div>
        }
        footer={footer}
      />
    );
  }
  let content = <></>;
  if (collectionName !== 'BitcoinDegen')
    content = (
      <div className="degen-collection-container">
        {nftsOwned.map((nft) => (
          <div key={nft} className="card select-collection-card degen-collection-card" onClick={onSelectDegen(nft)}>
            <img className="card-img-top" src={`${baseSource}${nft}.png`} alt={`Card image cap ${nft}`} />
            <div className="card-body">
              <h3 className="card-title card-lead">
                {collectionName}: #{nft}
              </h3>
            </div>
          </div>
        ))}
      </div>
    );
  else
    content = (
      <div className="degen-collection-container">
        {nftsOwned.map((nft) => (
          <div key={nft} className="card select-collection-card degen-collection-card" onClick={onSelectDegen(nft)}>
            <img className="card-img-top" src={`${baseSource}${nft}.png`} alt={`Card image cap ${nft}`} />
            <div className="card-body">
              <h3 className="card-title card-lead">
                {collectionName}: #{nft}
              </h3>
            </div>
          </div>
        ))}
      </div>
    );

  return <MenuContainer content={content} footer={footer} />;
};
